@for (nav of fillerNav(); track nav) {
  <button mat-button routerLink="." [routerLink]="nav.path">
    {{ nav.path | uppercase }}
  </button>
}
